<template>
  <div>
    <b-modal id="scretDictionaryDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">{{title}} 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{scretDictionaryData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                              <th>등록자</th>
                              <td><span>{{scretDictionaryData.nick_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>질병카테고리</th>
                                <td><span>{{scretDictionaryData.prescribe_category_nm}}</span></td>
                            </tr>
                            <tr>
                              <th>상세카테고리</th>
                              <td><span>{{scretDictionaryData.prescribe_sub_category_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><span>{{scretDictionaryData.prescribe_source}}</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{scretDictionaryData.prescribe_medicine}}</span></td>
                            </tr>
                            <tr>
                                <th>적응증</th>
                                <td><span>{{scretDictionaryData.indications}}</span></td>
                            </tr>
                            <tr>
                              <th>사용기준</th>
                              <td>
                                <span>{{scretDictionaryData.usage_criteria_day}}</span>일분
                                <span>{{scretDictionaryData.usage_criteria_dose}}</span>첩
                                <span>{{scretDictionaryData.usage_criteria_pack}}</span>팩
                                <span>{{scretDictionaryData.usage_criteria_unit}}</span>ml
                              </td>
                            </tr>
                            <tr>
                                <th>처방설명 및 가감</th>
                                <td><span>{{scretDictionaryData.secret_prescription_adjust}}</span></td>
                            </tr>
                            <tr>
                                <th>참고사항</th>
                                <td><span>{{scretDictionaryData.remarks}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="title_sm">
                        <h3 class="tb_title">비방 사전 리뷰</h3>
                        <div class="flex items-center gap4">
                            평균 별점 :
                            <div>
                            <StarRating :rating="scretDictionaryData.avgStarRate" />
                            </div>
                        </div>
                    </div>
                    <div class="review-table-wrapper">
                        <table class="list">
                            <colgroup>
                                <col width="100" />
                                <col width="100" />
                                <col width="100" />
                            </colgroup>
                            <tbody>
                                <tr>
                                <th>답변자</th>
                                <th>종합평가</th>
                                <th>별점</th>
                                </tr>

                                <tr v-if="scretDictionaryData.reviewList.length == 0">
                                    <td colspan="3"><span>데이터가 없습니다.</span></td>
                                </tr>
                                <tr v-for="(item, index) in scretDictionaryData.reviewList"
                                    :key="index"
                                    @click="fn_open_review_detail(item)"
                                >
                                    <td><span>{{item.nick_nm}}</span></td>
                                    <td><span>{{item.review_content}}</span></td>
                                    <td>
                                        <StarRating :rating="item.clinical_rating" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>
    <review-detail-modal ref="reviewDetailModal" />
  </div>
</template>

<script>

    import StarRating from "@/components/common/StarRating.vue";
    import ReviewDetailModal from "@/modal/user/reviewDetailModal.vue";

    export default {
        name: 'dictionaryDetailModal',
        components: {
            StarRating,
            ReviewDetailModal
        },
        props: {
            title: String,
            scretDictionaryData : {
                prescribe_nm : '',
                prescribe_source : '',
                prescribe_medicine : '',
                prescribe_category : '',
                prescribe_category_nm : '',
                indications : '',
                secret_prescription_adjust : '',
                remarks : '',
                item : {},
                avgStarRate : 0,
                reviewList : []
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.scretDictionaryData.item);
            },
            fn_open_review_detail(item){
                this.$refs.reviewDetailModal.open(item);
            }
        },
        data () {
            return {
            }
        }
    }
</script>

<style lang="scss" scoped>
.table_list {
  table.write {
    tr {
      th,
      td {
        height: 32px;
        min-height: 32px;
        line-height: 1.3;
        padding: 2px 12px;
        border-bottom: 1px solid #dacebd !important;
      }
    }
    tr:last-child {
      th,
      td {
        border-bottom: 0 !important;
      }
    }
  }
}

.review-table-wrapper {
  border: 1px solid #dacebd;
  border-radius: 8px;
  max-height: 216px;
  overflow-y: auto;
  overflow-x: hidden;

  table.list {
    border-top: 0;

    tr {
      th,
      td {
        height: 36px;
        line-height: 36px;
      }
    }

    tr:first-child {
      th {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: #edeeef;
      }
    }
  }
}
</style>